import { getActiveNavIdFromPathRegistry } from '@repo/shared-config';

/**
 * Maps the URL path back to a nav item ID for sidebar highlighting.
 * Delegates to the centralized navigation registry.
 */
export const getActiveNavIdFromPath = (pathname: string): string =>
  getActiveNavIdFromPathRegistry(pathname);
